import React, { useCallback, useEffect, useState } from "react";
import { FileSpreadsheet, Check, X } from "lucide-react";
import { toast } from "sonner";
import { api, arabicError } from "../lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("ar-SY", { timeZone: "Asia/Damascus", dateStyle: "medium", timeStyle: "short" }) : "—");

export default function AdminExportApprovals() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(null);
  const load = useCallback(async () => { try { const r = await api.get("/admin/export-approvals", { params: { status: "pending" } }); setRows(r.data); } catch { setRows([]); } }, []);
  useEffect(() => { load(); }, [load]);
  const act = async (id, action) => {
    setBusy(id);
    try { const r = await api.post(`/admin/export-approvals/${id}/${action}`); toast.success(r.data.message); load(); }
    catch (e) { toast.error(arabicError(e)); } finally { setBusy(null); }
  };
  return (
    <div className="bg-white border border-[#7AB2B2] rounded-xl p-5 min-w-0" data-testid="admin-export-approvals">
      <div className="flex items-center gap-2 mb-3">
        <FileSpreadsheet className="text-emerald-700" size={20} />
        <h2 className="text-lg font-bold text-[#333333]">طلبات تصدير Excel</h2>
        <span className="text-xs font-bold text-[#666666] tabular-nums" data-testid="admin-export-approvals-count">({rows.length})</span>
        <span className="text-[11px] text-[#888888]">الموافقة تمنح التاجر كل تصديرات Excel لمدة 24 ساعة</span>
      </div>
      {rows.length === 0 ? (
        <div className="text-sm text-[#888888]" data-testid="admin-export-approvals-empty">لا توجد طلبات معلّقة</div>
      ) : (
        <div className="space-y-2">
          {rows.map((r) => (
            <div key={r.id} className="flex flex-wrap items-center justify-between gap-2 border border-[#EBF4F6] rounded-lg p-3 min-w-0" data-testid={`export-approval-row-${r.id}`}>
              <div className="min-w-0">
                <div className="font-bold text-[#333333] text-sm truncate">{r.store_name || "—"} <span className="text-[#888888] font-normal">· {r.city || ""}</span></div>
                <div className="text-xs text-[#666666] truncate" dir="ltr">{r.email}</div>
                <div className="text-[11px] text-[#888888] tabular-nums">طُلب في {fmt(r.requested_at)}</div>
              </div>
              <div className="flex gap-2 shrink-0">
                <button onClick={() => act(r.id, "approve")} disabled={busy === r.id} data-testid={`export-approve-${r.id}`}
                  className="h-9 px-3 rounded-lg bg-emerald-700 hover:bg-emerald-800 text-white text-xs font-bold flex items-center gap-1 disabled:opacity-60"><Check size={14} /> موافقة 24 ساعة</button>
                <button onClick={() => act(r.id, "reject")} disabled={busy === r.id} data-testid={`export-reject-${r.id}`}
                  className="h-9 px-3 rounded-lg border border-rose-300 text-rose-700 hover:bg-rose-50 text-xs font-bold flex items-center gap-1 disabled:opacity-60"><X size={14} /> رفض</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
